import findAllButById from 'helpers/findAllButById'

export default function removeCamera(state, action) {
  const { idToSwitchTo, id } = action
  const { cameras } = state
  const cameraToSwitchTo = idToSwitchTo && Object.assign({}, cameras.find(c => c.id === idToSwitchTo), { active: true })

  const cameraToAdd = [cameraToSwitchTo].filter(c => typeof c !== 'undefined')

  return Object.assign(
    {},
    state,
    {
      cameras: findAllButById({ state: cameras, id })
                .filter(c => c.id !== idToSwitchTo)
                .concat(...cameraToAdd),
      currentEntity: idToSwitchTo ? { type: 'camera', id: idToSwitchTo } : { type: 'map' }
    }
  )
}



// WEBPACK FOOTER //
// ./src/reducers/removeCamera.js